import reduce from 'lodash/reduce';
import split from 'lodash/split';
const EXTERNAL_URL_REGEX = /^(http:|https:)?\/\//i;
const PROTOCOL_DELIMITER_REGEXES = [/:?$/, /(:\/\/)?$/];
const PROTOCOL_DELIMITER = '://';
/**
 * Determines whether the url is external or internal url. e.g. http/s.
 * @param {string} url to check whether is external or not.
 * @returns {boolean}
 */
export function isExternalUrl(url) {
    return EXTERNAL_URL_REGEX.test(url);
}
/**
 * Determines whether url has a supported protocol
 * @param {string} url to check whether it is in list of supported protocols
 * @param {string[]} protocols an array of supported protocols.
 * @returns {boolean}
 */
export function isTrustedProtocol(url, protocols) {
    if (!url || !protocols) {
        return false;
    }
    return protocols.some(protocol => {
        return url.startsWith(`${PROTOCOL_DELIMITER_REGEXES.reduce((protocolValue, regex) => {
            return protocolValue.replace(regex, '');
        }, protocol)}${PROTOCOL_DELIMITER}`);
    });
}
/**
 * Transforms URL's query params into an array of objects
 * In absence of query params returns an empty object
 * @param {string} url with query params.
 * @returns Record<string, any>
 */
export function getQueryParams(url) {
    const queryParams = split(url, '?')[1];
    const paramsArray = split(queryParams, '&');
    return queryParams ? reduce(paramsArray, (result, item) => {
        const [key, value] = item.split('=');
        return Object.assign(Object.assign({}, result), { [key]: value });
    }, {}) : {};
}
